var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portal"},[(_vm.userGroupID === 1)?_c('appDecsa'):(_vm.userGroupID === 4)?_c('appCarrier'):(_vm.userGroupID === 6)?_c('appConsignee'):_c('appPublic')],1)}
var staticRenderFns = []

export { render, staticRenderFns }